import React from "react";
import { Helmet } from "react-helmet-async";

const SiteNavigation: React.FC = () => {
  const navigationSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "わかば接骨院サイトナビゲーション",
    description: "わかば接骨院の主要ページ一覧",
    numberOfItems: 8,
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "ホーム",
        description:
          "わかば接骨院のホームページ。当院の特徴と施術方針をご紹介。",
        url: "https://wakabaseto.jp/",
        item: {
          "@type": "WebPage",
          name: "ホーム",
          description:
            "わかば接骨院のホームページ。当院の特徴と施術方針をご紹介。",
          url: "https://wakabaseto.jp/",
          mainEntity: {
            "@type": "MedicalBusiness",
            name: "わかば接骨院",
          },
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "当院について",
        description:
          "わかば接骨院の理念と院長紹介。36年の経験を持つ柔道整復師・鍼灸師が在籍。",
        url: "https://wakabaseto.jp/about",
        item: {
          "@type": "WebPage",
          name: "当院について",
          description:
            "わかば接骨院の理念と院長紹介。36年の経験を持つ柔道整復師・鍼灸師が在籍。",
          url: "https://wakabaseto.jp/about",
          mainEntity: {
            "@type": "Person",
            name: "住田雅美",
            jobTitle: "院長",
            worksFor: {
              "@type": "MedicalBusiness",
              name: "わかば接骨院",
            },
          },
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "施術メニュー",
        description:
          "接骨施術と鍼灸施術の詳細メニュー。五十肩・腰痛施術に特化。",
        url: "https://wakabaseto.jp/services",
        item: {
          "@type": "WebPage",
          name: "施術メニュー",
          description:
            "接骨施術と鍼灸施術の詳細メニュー。五十肩・腰痛施術に特化。",
          url: "https://wakabaseto.jp/services",
          mainEntity: {
            "@type": "OfferCatalog",
            name: "施術メニュー",
            itemListElement: [
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "接骨施術",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "鍼灸施術",
                },
              },
            ],
          },
        },
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "アクセス",
        description:
          "わかば接骨院へのアクセス情報。新瀬戸駅徒歩10分、専用駐車場9台。",
        url: "https://wakabaseto.jp/access",
        item: {
          "@type": "WebPage",
          name: "アクセス",
          description:
            "わかば接骨院へのアクセス情報。新瀬戸駅徒歩10分、専用駐車場9台。",
          url: "https://wakabaseto.jp/access",
          mainEntity: {
            "@type": "Place",
            name: "わかば接骨院",
            address: {
              "@type": "PostalAddress",
              streetAddress: "共栄通3-5",
              addressLocality: "瀬戸市",
              addressRegion: "愛知県",
              postalCode: "489-0809",
              addressCountry: "JP",
            },
          },
        },
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "お問い合わせ",
        description:
          "わかば接骨院へのお問い合わせ・ご予約。お気軽にご連絡ください。",
        url: "https://wakabaseto.jp/contact",
        item: {
          "@type": "WebPage",
          name: "お問い合わせ",
          description:
            "わかば接骨院へのお問い合わせ・ご予約。お気軽にご連絡ください。",
          url: "https://wakabaseto.jp/contact",
          mainEntity: {
            "@type": "ContactPage",
            name: "お問い合わせ",
            description: "わかば接骨院へのお問い合わせ・ご予約",
          },
        },
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "プライバシーポリシー",
        description:
          "わかば接骨院のプライバシーポリシー。個人情報の取り扱いについて説明しています。",
        url: "https://wakabaseto.jp/privacy-policy",
        item: {
          "@type": "WebPage",
          name: "プライバシーポリシー",
          description:
            "わかば接骨院のプライバシーポリシー。個人情報の取り扱いについて説明しています。",
          url: "https://wakabaseto.jp/privacy-policy",
          mainEntity: {
            "@type": "WebPage",
            name: "プライバシーポリシー",
            description: "個人情報保護方針",
          },
        },
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "利用規約",
        description:
          "わかば接骨院の利用規約。ウェブサイトの利用条件について説明しています。",
        url: "https://wakabaseto.jp/terms-of-service",
        item: {
          "@type": "WebPage",
          name: "利用規約",
          description:
            "わかば接骨院の利用規約。ウェブサイトの利用条件について説明しています。",
          url: "https://wakabaseto.jp/terms-of-service",
          mainEntity: {
            "@type": "WebPage",
            name: "利用規約",
            description: "ウェブサイト利用条件",
          },
        },
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "サイトマップ",
        description:
          "わかば接骨院のサイトマップ。ウェブサイトの構造をご案内します。",
        url: "https://wakabaseto.jp/sitemap",
        item: {
          "@type": "WebPage",
          name: "サイトマップ",
          description:
            "わかば接骨院のサイトマップ。ウェブサイトの構造をご案内します。",
          url: "https://wakabaseto.jp/sitemap",
          mainEntity: {
            "@type": "WebPage",
            name: "サイトマップ",
            description: "ウェブサイトの構造",
          },
        },
      },
    ],
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "ホーム",
        item: "https://wakabaseto.jp/",
      },
    ],
  };

  return (
    <Helmet>
      {/* Site Navigation Schema */}
      <script type="application/ld+json">
        {JSON.stringify(navigationSchema)}
      </script>

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default SiteNavigation;
